import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiConnecter } from "../services/apiConnector";
import API_ENDPOINTS from "../constant/EndPoints";
/**
 * Custom hook to fetch the click timeline analytics data for a specific event.
 *
 * @param {object} params - The hook parameters.
 * @param {string} params.eventId - The unique ID of the event to fetch analytics for.
 * @returns {UseClickTimelineResult} An object containing the raw data, loading state, and error.
 */

function useFeefbackFormTimeline({ eventId }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const userInfo = useSelector((state) => state.userInfo);
    const token = userInfo?.token;

    useEffect(() => {
        const fetchClickTimeline = async () => {
            if (!eventId) {
                setError('Event Id Not Found');
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const url = `${API_ENDPOINTS.REACT_APP_GET_FEEDBACK_FORM_ANALYTICS_BY_ID_END_POINT}/${eventId}`;
                const res = await apiConnecter('GET', url, null, { authorization: `Bearer ${userInfo.token}` });
                if (res?.data?.status) {
                    setData(res.data.result);
                } else {
                    setError(res?.data?.message || 'Failed to fetch analytics data');
                }
            } catch (err) {
                console.error('ClickTimeline fetch error:', err);
                setError(err?.response?.data?.message ?? 'Failed to fetch analytics data');
            } finally {
                setLoading(false);
            }
        };

        fetchClickTimeline();
    }, [eventId, token]);

    return { data, loading, error };
}

export default useFeefbackFormTimeline;